module.exports = __webpack_public_path__ + "img/play_minimal.d5535ab9.svg";